import { render, staticRenderFns } from "./welfare-card-list.vue?vue&type=template&id=13fd2cd9&scoped=true"
import script from "./welfare-card-list.vue?vue&type=script&lang=js"
export * from "./welfare-card-list.vue?vue&type=script&lang=js"
import style0 from "./welfare-card-list.vue?vue&type=style&index=0&id=13fd2cd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd2cd9",
  null
  
)

export default component.exports